import chargeUrlSearchParams from 'views/assets/scripts/chargeUrlSearchParams'
import nowModal from 'views/assets/scripts/nowModal'
import runScripts from 'views/assets/scripts/runScripts'
import initClientScriptsXsellSellerModal from 'views/components/organisms/XsellSellerModal/initClientScripts'
import mountOffersContainer from 'views/containers/browser/OffersContainer/mountOffersContainer'

runScripts(
  nowModal,
  chargeUrlSearchParams,
  mountOffersContainer,
  initClientScriptsXsellSellerModal
)
